import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { FieldErrors, FieldPath, FieldValues } from 'react-hook-form';

export const useFormErrorMessage = <
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  name: TFieldName,
  label: string,
  errors: FieldErrors<TFieldValues>
) => {
  const { t } = useTranslation('forms');

  const error = errors[name];
  const errorMessage = useMemo(() => {
    if (!error) {
      return null;
    }

    if (typeof error.message === 'string' && error.message) {
      return error.message;
    }

    switch (error.type) {
      case 'invalid':
        return t('form.validationError.invalid', { field: label || name });
      default:
        return t('form.validationError.required', { field: label || name });
    }
  }, [error, label, name, t]);

  return errorMessage;
};
